/* eslint-disable */
import {
  hiprint
} from '../../index'

// 自定义设计元素1
export const aProvider = function (ops) {
  var addElementTypes = function (context) {
    context.removePrintElementTypes("aProviderModule");
    context.addPrintElementTypes(
      "aProviderModule",
      [
        new hiprint.PrintElementTypeGroup("组件", [{
            tid: 'aProviderModule.header',
            title: '单据表头',
            data: '单据表头',
            type: 'text',
            options: {
              testData: '单据表头',
              height: 17,
              fontSize: 18.5,
              fontWeight: "900",
              textAlign: "center",
              hideTitle: true
            }
          },
          {
            tid: 'aProviderModule.order',
            title: '申请单号',
            data: 'XS888888888',
            type: 'text',
            options: {
              field: 'billNo',
              testData: 'XS888888888',
              height: 16,
              fontSize: 16.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.name',
            title: '姓名',
            data: '张三',
            type: 'text',
            options: {
              field: 'patientName',
              testData: '张三',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.sex',
            title: '性别',
            data: '男',
            type: 'text',
            options: {
              field: 'sex',
              testData: '男',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.age',
            title: '年龄',
            data: '25岁',
            type: 'text',
            options: {
              field: 'age',
              testData: '25岁',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.projectName',
            title: '检查项目',
            data: 'CT检查',
            type: 'text',
            options: {
              field: 'projectName',
              testData: 'CT检查',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.partNames',
            title: '检查部位',
            data: '头部',
            type: 'text',
            options: {
              field: 'partNames',
              testData: '头部',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.billDoctorName',
            title: '开单医生',
            data: '李四',
            type: 'text',
            options: {
              field: 'billDoctorName',
              testData: '李四',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.billDeptName',
            title: '开单科室',
            data: '放射科',
            type: 'text',
            options: {
              field: 'billDeptName',
              testData: '放射科',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.exeDeptName',
            title: '执行科室',
            data: '放射科',
            type: 'text',
            options: {
              field: 'exeDeptName',
              testData: '放射科',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.checkTime',
            title: '检查时间',
            data: '2023-01-01 11:11:11',
            type: 'text',
            options: {
              field: 'checkTime',
              testData: '2023-01-01 11:11:11',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.resourceName',
            title: '检查室',
            data: 'CT1检查室',
            type: 'text',
            options: {
              field: 'resourceName',
              testData: 'CT1检查室',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.place',
            title: '检查地点',
            data: '门诊三楼',
            type: 'text',
            options: {
              field: 'place',
              testData: '门诊三楼',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'aProviderModule.barcode',
            title: '条形码',
            data: '7022113',
            type: 'text',
            options: {
              field: 'barcode',
              testData: '7022113',
              height: 32,
              fontSize: 12,
              lineHeight: 18,
              textType: "barcode"
            }
          },
          {
            tid: 'aProviderModule.longText',
            title: '注意事项',
            type: 'longText',
            options: {
              field: 'note',
              width: 200,
              fontSize: 9.75,
              fontWeight: "600",
              testData: '注意事项'
            },
          },
          {
            tid: 'aProviderModule.nowTime',
            title: '打印时间',
            data: '2023-01-01 11:11:11',
            type: 'text',
            options: {
              field: 'nowTime',
              testData: '2023-01-01 11:11:11',
              height: 16,
              fontSize: 10.75,
              fontWeight: "600",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
        ]),
        new hiprint.PrintElementTypeGroup("辅助", [{
            tid: 'aProviderModule.hline',
            title: '横线',
            type: 'hline'
          },
          {
            tid: 'aProviderModule.vline',
            title: '竖线',
            type: 'vline'
          },
          // {
          //   tid: 'aProviderModule.rect',
          //   title: '矩形',
          //   type: 'rect'
          // },
          // {
          //   tid: 'aProviderModule.oval',
          //   title: '椭圆',
          //   type: 'oval'
          // }
        ])
      ]
    );
  };
  return {
    addElementTypes: addElementTypes
  };
};

// 自定义设计元素2
export const bProvider = function (ops) {
  var addElementTypes = function (context) {
    context.removePrintElementTypes("bProviderModule");
    context.addPrintElementTypes(
      "bProviderModule",
      [
        new hiprint.PrintElementTypeGroup("常规", [{
            tid: 'bProviderModule.header',
            title: '单据表头',
            data: '单据表头',
            type: 'text',
            options: {
              testData: '单据表头',
              height: 17,
              fontSize: 16.5,
              fontWeight: "700",
              textAlign: "center",
              hideTitle: true
            }
          },
          {
            tid: 'bProviderModule.type',
            title: '单据类型',
            data: '单据类型',
            type: 'text',
            options: {
              testData: '单据类型',
              height: 16,
              fontSize: 15,
              fontWeight: "700",
              textAlign: "center",
              hideTitle: true
            }
          },
          {
            tid: 'bProviderModule.order',
            title: '订单编号',
            data: 'XS888888888',
            type: 'text',
            options: {
              field: 'orderId',
              testData: 'XS888888888',
              height: 16,
              fontSize: 6.75,
              fontWeight: "700",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.date',
            title: '业务日期',
            data: '2020-01-01',
            type: 'text',
            options: {
              field: 'date',
              testData: '2020-01-01',
              height: 16,
              fontSize: 6.75,
              fontWeight: "700",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.barcode',
            title: '条形码',
            data: 'XS888888888',
            type: 'text',
            options: {
              field: 'barcode',
              testData: 'XS888888888',
              height: 32,
              fontSize: 12,
              lineHeight: 18,
              textType: "barcode"
            }
          },
          {
            tid: 'bProviderModule.qrcode',
            title: '二维码',
            data: 'XS888888888',
            type: 'text',
            options: {
              field: 'qrcode',
              testData: 'XS888888888',
              height: 32,
              fontSize: 12,
              lineHeight: 18,
              textType: "qrcode"
            }
          },
          {
            tid: 'bProviderModule.platform',
            title: '平台名称',
            data: '平台名称',
            type: 'text',
            options: {
              testData: '平台名称',
              height: 17,
              fontSize: 16.5,
              fontWeight: "700",
              textAlign: "center",
              hideTitle: true
            }
          },
          {
            tid: 'bProviderModule.image',
            title: 'Logo',
            data: '',
            type: 'image'
          },
        ]),
        new hiprint.PrintElementTypeGroup("客户", [{
            tid: 'bProviderModule.khname',
            title: '客户名称',
            data: '高级客户',
            type: 'text',
            options: {
              field: 'name',
              testData: '高级客户',
              height: 16,
              fontSize: 6.75,
              fontWeight: "700",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
          {
            tid: 'bProviderModule.tel',
            title: '客户电话',
            data: '18888888888',
            type: 'text',
            options: {
              field: 'tel',
              testData: '18888888888',
              height: 16,
              fontSize: 6.75,
              fontWeight: "700",
              textAlign: "left",
              textContentVerticalAlign: "middle"
            }
          },
        ]),
        new hiprint.PrintElementTypeGroup("表格/其他", [{
            tid: 'bProviderModule.table',
            title: '订单数据',
            type: 'table',
            options: {
              field: 'table',
              fields: [{
                  text: '名称',
                  field: 'NAME'
                },
                {
                  text: '数量',
                  field: 'SL'
                },
                {
                  text: '规格',
                  field: 'GG'
                },
                {
                  text: '条码',
                  field: 'TM'
                },
                {
                  text: '单价',
                  field: 'DJ'
                },
                {
                  text: '金额',
                  field: 'JE'
                },
                {
                  text: '备注',
                  field: 'DETAIL'
                },
              ],
            },
            editable: true,
            columnDisplayEditable: true, //列显示是否能编辑
            columnDisplayIndexEditable: true, //列顺序显示是否能编辑
            columnTitleEditable: true, //列标题是否能编辑
            columnResizable: true, //列宽是否能调整
            columnAlignEditable: true, //列对齐是否调整
            columns: [
              [{
                  title: '名称',
                  align: 'center',
                  field: 'NAME',
                  width: 100
                },
                {
                  title: '数量',
                  align: 'center',
                  field: 'SL',
                  width: 100
                },
                {
                  title: '条码',
                  align: 'center',
                  field: 'TM',
                  width: 100
                },
                {
                  title: '规格',
                  align: 'center',
                  field: 'GG',
                  width: 100
                },
                {
                  title: '单价',
                  align: 'center',
                  field: 'DJ',
                  width: 100
                },
                {
                  title: '金额',
                  align: 'center',
                  field: 'JE',
                  width: 100
                },
                {
                  title: '备注',
                  align: 'center',
                  field: 'DETAIL',
                  width: 100
                },
              ]
            ],
            footerFormatter: function (options, rows, data, currentPageGridRowsData) {
              if (data && data['totalCap']) {
                return `<td style="padding:0 10px" colspan="100">${'应收金额大写: ' + data['totalCap']}</td>`
              }
              return '<td style="padding:0 10px" colspan="100">应收金额大写: </td>'
            },
          },
          {
            tid: 'bProviderModule.customText',
            title: '文本',
            customText: '自定义文本',
            custom: true,
            type: 'text'
          },
          {
            tid: 'bProviderModule.longText',
            title: '长文本',
            type: 'longText',
            options: {
              field: 'test.longText',
              width: 200,
              testData: '长文本分页/不分页测试'
            },
          }
        ]),
        new hiprint.PrintElementTypeGroup("辅助", [{
            tid: 'bProviderModule.hline',
            title: '横线',
            type: 'hline'
          },
          {
            tid: 'bProviderModule.vline',
            title: '竖线',
            type: 'vline'
          },
          {
            tid: 'bProviderModule.rect',
            title: '矩形',
            type: 'rect'
          },
          {
            tid: 'bProviderModule.oval',
            title: '椭圆',
            type: 'oval'
          }
        ])
      ]
    );
  };
  return {
    addElementTypes: addElementTypes
  };
};

// type: 1供货商 2经销商
export default [{
    name: 'A设计',
    value: 'aProviderModule',
    type: 1,
    f: aProvider()
  },
  //  {
  //   name: 'B设计',
  //   value: 'bProviderModule',
  //   type: 2,
  //   f: bProvider()
  // }
]